import DashboardPage from "@pages/dashboard";

const HomePage = () => {
    return <DashboardPage />
}

export default HomePage;